import React from 'react';
import block from 'bem-cn';

import Button from 'components/Button';

import './PopUp.scss';

const b = block('password-pop-up');

const PopUp = ({ password, id, locale, onClose }) => {
  return (
    <div className={b()}>
      <div className={b('body')}>
        <div className={b('header')}>{`${locale.theNewPassword} ${locale.for} ${locale.id.toLowerCase()} ${id}`}</div>
        <div className={b('password')}>{password}</div>
        <div className={b('button')}>
          <Button onClick={() => onClose(false)}>{locale.ok}</Button>
        </div>
      </div>
    </div>
  );
};

export default PopUp;
